import ContactForm from "../components/views/users/contact-us/ContactForm";
import Hero from "../components/views/users/contact-us/Hero";
import GetStarted from "../components/views/users/home/GetStarted";

const ContactUs = () => {
  return (
    <div>
      <Hero />
      <ContactForm />
      <GetStarted />
    </div>
  );
};

export default ContactUs;
